import * as React from 'react';
import { SVGProps } from 'react';

const PaddleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
    <g fill="currentColor" clipPath="url(#a)">
      <path d="m11.45 14.142 1.853-.977 2.44 4.63c.489.925-1.363 1.901-1.851.976l-2.441-4.63Z" />
      <path
        fillRule="evenodd"
        d="M3.405 10.103c-3.208-6.07 7.903-11.95 11.11-5.858 1.464 2.776 1.026 4.19.588 5.604-.132.428-.33.836-.544 1.281-.496 1.026-1.088 2.251-1.205 4.376-1.82-1.104-3.165-1.307-4.292-1.477-.489-.074-.937-.142-1.365-.274-1.414-.438-2.828-.876-4.292-3.652Zm6.845 2.684v.771h.77v-.77h-.77Zm1.542 0v-.77h.77v.77h-.77Zm-.771-2.312v.77h.77v-.77h-.77Zm1.541.77v-.77h.74v.77h-.74Zm.792-2.312v.771h.75v-.77h-.75Zm-5.417 3.854v-.77h.771v.77h-.77Zm1.542-1.541v.77h.771v-.77h-.77Zm-.77-2.313v-.77h.77v.77h-.77Zm-.772 1.542v.77h.771v-.77h-.77Zm-1.541 1.542v-.771h.77v.77h-.77ZM4.854 9.704v.771h.771v-.77h-.77Zm-.77-1.541v-.771h.77v.77h-.77Zm1.541-3.084v.771h.77v-.77h-.77Zm6.938.771v-.77h.74v.77h-.74Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default PaddleIcon;
